module.exports = __webpack_public_path__ + "img/certificate.335572ad.png";